import { getDatabase, ref, child, get } from "firebase/database";

/**
 * Get all students from an event
 * @param {String} eventId 
 * @returns Array of all students
 */
const getStudentsFromEvent = async (eventId) => {

    const dbRef = ref(getDatabase());
    let snapshot = await get(child(dbRef, `events/${eventId}/students`))
    if (snapshot.exists()) {
        let students = snapshot.val();
        let studentsList = []
        for (var prop in students) {
            if (!students[prop].wasDeleted) {
                let localObj = students[prop];
                localObj['__key'] = prop;
                studentsList.push(localObj);
            }
        };

        // Order by faixa
        studentsList.sort(function (a, b) { return (a.faixa > b.faixa) ? 1 : ((b.faixa > a.faixa) ? -1 : 0) });

        return studentsList;
    } else {
        return [];
    }
}

/**
 * Get all teams from a student list
 * @param {Array} competitorsList 
 * @returns Array of all teams
 */
const getTeamsFromStudents = async (competitorsList) => {
    let teams = competitorsList.map(el => el.equipe);
    teams = [...new Set(teams)];
    return teams;
}

export {
    getStudentsFromEvent,
    getTeamsFromStudents,
}